import httpClientFactory from './httpClientFactory';
import refreshToken from './refreshToken';

export default (api) => {
  const authenticatedHttpClient = httpClientFactory(api);

  authenticatedHttpClient.interceptors.response.use(
    (response) => { return response; },
    async(error) => {
      if (error.response.status === 401) {
        const response = await refreshToken(error);
        return response;
      }
      throw error;
    },
  );

  return authenticatedHttpClient;
};
